import { boronClient } from "../../../../../api";
import { paths } from "../../../../../lib/api/v1";
import { Tag } from ".";
import { buildQueryParams } from "./buildQueryParams";
import { downloadCsvFile } from "./downloadCsvFile";

export type ResponseSchema =
  paths[typeof path]["get"]["responses"]["200"]["content"]["text/csv"];

export const path =
  "/api/v1/sections/{section_id}/exports/students_for_student_passcode_inactivation.csv";

export const NO_STUDENT_ERROR =
  "選択したタグに含まれる連携中・招待中の生徒が存在しません";

export const downloadCsvForStudentPasscodeInactivation = async (
  sectionId: string,
  selectedTags: Tag[],
): Promise<ResponseSchema> => {
  const queryParams = buildQueryParams(selectedTags);

  const { response, data, error } = await boronClient.GET(path, {
    params: {
      path: { section_id: sectionId },
      query: queryParams,
    },
    parseAs: "text",
  });

  if (response.status === 204) {
    throw new Error(NO_STUDENT_ERROR);
  }

  if (error || !response.ok) {
    throw error;
  }

  downloadCsvFile(data);
  return data;
};
